import * as React from 'react';
import type { SVGProps } from 'react';
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgVerkeerdMat = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width={24}
    height={24}
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <g clipPath='url(#clip0_3241_8949)'>
      <path d='M22 4V14C22 15.1 21.1 16 20 16H16V15H20C20.55 15 21 14.55 21 14V4C21 3.45 20.55 3 20 3H10C9.45 3 9 3.45 9 4V8H8V4C8 2.9 8.9 2 10 2H20C21.1 2 22 2.9 22 4ZM14 12.12V20.11C14 20.6 13.6 20.99 13.12 20.99H3.88C3.39 20.99 3 20.59 3 20.11V10.88C3 10.39 3.4 10 3.88 10H11.87L12.87 9H3.88C2.84 9 2 9.85 2 10.88V20.11C2 21.15 2.85 21.99 3.88 21.99H13.11C14.15 21.99 14.99 21.14 14.99 20.11V11.12L13.99 12.12H14ZM13.92 6C13.64 6 13.42 6.22 13.42 6.5C13.42 6.78 13.64 7 13.92 7H16.3L7.15 16.15C6.95 16.35 6.95 16.66 7.15 16.86C7.25 16.96 7.38 17.01 7.5 17.01C7.62 17.01 7.76 16.96 7.85 16.86L17 7.71V10.09C17 10.37 17.22 10.59 17.5 10.59C17.78 10.59 18 10.37 18 10.09V6.01H13.92V6Z' />
    </g>
    <defs>
      <clipPath>
        <rect width={24} height={24} fill='white' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgVerkeerdMat;
